var _rect, _path, _rect2, _rect3, _rect4, _path2, _path3, _line, _circle, _circle2, _path4, _line2, _circle3, _circle4, _path5, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _path6, _path7, _line31, _path8, _path9, _line32, _path0, _line33, _path1, _path10, _line34, _rect5, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _path11, _path12, _line55, _g, _path13, _g2, _path14, _g3, _path15, _g4, _path16, _g5, _path17, _g6, _path18, _g7, _path19, _g8, _path20, _g9, _path21, _g0, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1380,
    height: 1050,
    viewBox: "0 0 1380 1050",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 91,
    width: 1157,
    height: 67,
    fill: "#222020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1230.5 358C1250.13 358 1269.57 354.547 1287.71 347.838C1305.85 341.129 1322.33 331.295 1336.21 318.899C1350.09 306.502 1361.11 291.785 1368.62 275.588C1376.13 259.391 1380 242.031 1380 224.5C1380 206.969 1376.13 189.609 1368.62 173.412C1361.11 157.215 1350.09 142.498 1336.21 130.101C1322.33 117.705 1305.85 107.871 1287.71 101.162C1269.57 94.4531 1250.13 91 1230.5 91L1230.5 157.75C1240.32 157.75 1250.04 159.477 1259.11 162.831C1268.17 166.186 1276.42 171.102 1283.36 177.301C1290.3 183.499 1295.8 190.857 1299.56 198.956C1303.32 207.054 1305.25 215.734 1305.25 224.5C1305.25 233.266 1303.32 241.946 1299.56 250.044C1295.8 258.143 1290.3 265.501 1283.36 271.699C1276.42 277.898 1268.17 282.814 1259.11 286.169C1250.04 289.523 1240.32 291.25 1230.5 291.25V358Z",
    fill: "#222020"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 491,
    width: 1083,
    height: 67,
    fill: "#222020"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 891,
    width: 1083,
    height: 67,
    fill: "#222020"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1083,
    height: 67,
    transform: "matrix(-1 0 0 1 1234 291)",
    fill: "#222020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 558C141.867 558 122.427 554.547 104.289 547.838C86.1507 541.129 69.6699 531.295 55.7875 518.899C41.9052 506.502 30.8931 491.785 23.38 475.588C15.8669 459.391 12 442.031 12 424.5C12 406.969 15.8669 389.609 23.38 373.412C30.8931 357.215 41.9052 342.498 55.7875 330.101C69.6699 317.705 86.1507 307.871 104.289 301.162C122.427 294.453 141.867 291 161.5 291L161.5 357.75C151.684 357.75 141.964 359.477 132.894 362.831C123.825 366.186 115.585 371.102 108.644 377.301C101.703 383.499 96.1965 390.857 92.44 398.956C88.6835 407.054 86.75 415.734 86.75 424.5C86.75 433.266 88.6835 441.946 92.44 450.044C96.1965 458.143 101.703 465.501 108.644 471.699C115.585 477.898 123.825 482.814 132.894 486.169C141.964 489.523 151.684 491.25 161.5 491.25V558Z",
    fill: "#222020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 958C141.867 958 122.427 954.547 104.289 947.838C86.1507 941.129 69.6699 931.295 55.7875 918.899C41.9052 906.502 30.8931 891.785 23.38 875.588C15.8669 859.391 12 842.031 12 824.5C12 806.969 15.8669 789.609 23.38 773.412C30.8931 757.215 41.9052 742.498 55.7875 730.101C69.6699 717.705 86.1507 707.871 104.289 701.162C122.427 694.453 141.867 691 161.5 691L161.5 757.75C151.684 757.75 141.964 759.477 132.894 762.831C123.825 766.186 115.585 771.102 108.644 777.301C101.703 783.499 96.1965 790.857 92.44 798.956C88.6835 807.054 86.75 815.734 86.75 824.5C86.75 833.266 88.6835 841.946 92.44 850.044C96.1965 858.143 101.703 865.501 108.644 871.699C115.585 877.898 123.825 882.814 132.894 886.169C141.964 889.523 151.684 891.25 161.5 891.25V958Z",
    fill: "#222020"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1084,
    y1: 922.5,
    x2: 1137,
    y2: 922.5,
    stroke: "white",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 925,
    r: 125,
    fill: "#0984FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1215,
    cy: 925,
    r: 98,
    fill: "#FF6F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.49 935.53C1145.22 935.53 1142.46 935.11 1140.2 934.27C1137.96 933.43 1136.25 932.205 1135.09 930.595C1133.94 928.962 1133.37 926.99 1133.37 924.68C1133.37 922.347 1133.94 920.375 1135.09 918.765C1136.25 917.132 1137.97 915.895 1140.23 915.055C1142.49 914.215 1145.26 913.795 1148.53 913.795C1148.57 913.795 1148.72 913.795 1148.98 913.795C1149.26 913.795 1149.54 913.795 1149.82 913.795C1150.1 913.795 1150.25 913.795 1150.28 913.795C1153.52 913.795 1156.24 914.227 1158.43 915.09C1160.65 915.93 1162.33 917.167 1163.47 918.8C1164.61 920.41 1165.19 922.37 1165.19 924.68C1165.19 926.967 1164.63 928.927 1163.51 930.56C1162.41 932.17 1160.78 933.407 1158.61 934.27C1156.44 935.11 1153.76 935.53 1150.59 935.53C1150.54 935.53 1150.36 935.53 1150.03 935.53C1149.7 935.53 1149.39 935.53 1149.09 935.53C1148.78 935.53 1148.58 935.53 1148.49 935.53ZM1149.12 930.21C1149.19 930.21 1149.3 930.21 1149.44 930.21C1149.6 930.21 1149.72 930.21 1149.79 930.21C1151.79 930.21 1153.44 930.012 1154.72 929.615C1156 929.218 1156.95 928.612 1157.56 927.795C1158.16 926.978 1158.47 925.928 1158.47 924.645C1158.47 923.338 1158.15 922.288 1157.52 921.495C1156.89 920.702 1155.95 920.118 1154.69 919.745C1153.43 919.348 1151.82 919.15 1149.86 919.15C1149.79 919.15 1149.67 919.15 1149.51 919.15C1149.37 919.15 1149.24 919.15 1149.12 919.15C1147.02 919.15 1145.31 919.337 1143.98 919.71C1142.65 920.083 1141.67 920.678 1141.04 921.495C1140.41 922.288 1140.09 923.35 1140.09 924.68C1140.09 925.987 1140.43 927.048 1141.11 927.865C1141.81 928.682 1142.82 929.277 1144.15 929.65C1145.5 930.023 1147.16 930.21 1149.12 930.21ZM1146.11 938.155V911.345H1152.45V938.155H1146.11ZM1170.54 937V912.5H1177.36V926.885L1187.48 912.5H1193.99V937H1187.16V922.65L1177.08 937H1170.54ZM1217.38 912.5H1224.31V937H1217.38V912.5ZM1207.93 937H1201V912.5H1207.93V937ZM1217.87 927.445H1207.44V921.705H1217.87V927.445ZM1231.32 937V912.5H1238.15V926.885L1248.26 912.5H1254.77V937H1247.95V922.65L1237.87 937H1231.32ZM1276.52 931.505L1275.01 933.045V912.5H1281.84V933.045L1280.26 931.505H1289.75L1288.17 933.045V912.5H1295V937H1261.78V912.5H1268.61V933.045L1267.1 931.505H1276.52Z",
    fill: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 243,
    y1: 122.5,
    x2: 313,
    y2: 122.5,
    stroke: "white",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "#0984FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 98,
    fill: "#FF6F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8144 137.49C71.8777 137.49 70.0811 137.187 68.4244 136.58C66.7911 135.95 65.3677 135.063 64.1544 133.92C62.9644 132.777 62.0311 131.435 61.3544 129.895C60.6777 128.332 60.3394 126.617 60.3394 124.75C60.3394 122.883 60.6777 121.18 61.3544 119.64C62.0311 118.077 62.9644 116.723 64.1544 115.58C65.3677 114.437 66.7911 113.562 68.4244 112.955C70.0811 112.325 71.8777 112.01 73.8144 112.01C76.0777 112.01 78.0961 112.407 79.8694 113.2C81.6661 113.993 83.1594 115.137 84.3494 116.63L79.9394 120.62C79.1461 119.687 78.2711 118.975 77.3144 118.485C76.3811 117.995 75.3311 117.75 74.1644 117.75C73.1611 117.75 72.2394 117.913 71.3994 118.24C70.5594 118.567 69.8361 119.045 69.2294 119.675C68.6461 120.282 68.1794 121.017 67.8294 121.88C67.5027 122.743 67.3394 123.7 67.3394 124.75C67.3394 125.8 67.5027 126.757 67.8294 127.62C68.1794 128.483 68.6461 129.23 69.2294 129.86C69.8361 130.467 70.5594 130.933 71.3994 131.26C72.2394 131.587 73.1611 131.75 74.1644 131.75C75.3311 131.75 76.3811 131.505 77.3144 131.015C78.2711 130.525 79.1461 129.813 79.9394 128.88L84.3494 132.87C83.1594 134.34 81.6661 135.483 79.8694 136.3C78.0961 137.093 76.0777 137.49 73.8144 137.49ZM94.4499 137V116.455L95.9899 117.995H86.9249V112.5H108.765V117.995H99.7349L101.275 116.455V137H94.4499ZM110.029 137L120.844 112.5H127.669L138.519 137H131.309L122.839 115.895H125.569L117.099 137H110.029ZM115.944 132.24L117.729 127.13H129.699L131.484 132.24H115.944ZM143.077 137V112.5H154.277C156.517 112.5 158.442 112.862 160.052 113.585C161.685 114.308 162.945 115.358 163.832 116.735C164.718 118.088 165.162 119.698 165.162 121.565C165.162 123.408 164.718 125.007 163.832 126.36C162.945 127.713 161.685 128.763 160.052 129.51C158.442 130.233 156.517 130.595 154.277 130.595H146.927L150.007 127.585V137H143.077ZM150.007 128.32L146.927 125.135H153.857C155.303 125.135 156.377 124.82 157.077 124.19C157.8 123.56 158.162 122.685 158.162 121.565C158.162 120.422 157.8 119.535 157.077 118.905C156.377 118.275 155.303 117.96 153.857 117.96H146.927L150.007 114.775V128.32ZM174.861 137V116.455L176.401 117.995H167.336V112.5H189.176V117.995H180.146L181.686 116.455V137H174.861Z",
    fill: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 363,
    y1: 122.5,
    x2: 416,
    y2: 122.5,
    stroke: "white",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 466,
    y1: 122.5,
    x2: 519,
    y2: 122.5,
    stroke: "white",
    strokeWidth: 5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 569,
    y1: 122.5,
    x2: 622,
    y2: 122.5,
    stroke: "white",
    strokeWidth: 5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 672,
    y1: 122.5,
    x2: 725,
    y2: 122.5,
    stroke: "white",
    strokeWidth: 5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 775,
    y1: 122.5,
    x2: 828,
    y2: 122.5,
    stroke: "white",
    strokeWidth: 5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 878,
    y1: 122.5,
    x2: 931,
    y2: 122.5,
    stroke: "white",
    strokeWidth: 5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 122.5,
    x2: 1034,
    y2: 122.5,
    stroke: "white",
    strokeWidth: 5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 1084,
    y1: 122.5,
    x2: 1137,
    y2: 122.5,
    stroke: "white",
    strokeWidth: 5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 1187,
    y1: 122.5,
    x2: 1240,
    y2: 122.5,
    stroke: "white",
    strokeWidth: 5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 322.5,
    x2: 303,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 353,
    y1: 322.5,
    x2: 406,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 147,
    y1: 322.5,
    x2: 200,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 466,
    y1: 322.5,
    x2: 519,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 569,
    y1: 322.5,
    x2: 622,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 672,
    y1: 322.5,
    x2: 725,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 775,
    y1: 322.5,
    x2: 828,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 878,
    y1: 322.5,
    x2: 931,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 322.5,
    x2: 1034,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 1084,
    y1: 322.5,
    x2: 1137,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 1187,
    y1: 322.5,
    x2: 1240,
    y2: 322.5,
    stroke: "white",
    strokeWidth: 5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 522.5,
    x2: 303,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 353,
    y1: 522.5,
    x2: 406,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 147,
    y1: 522.5,
    x2: 200,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 466,
    y1: 522.5,
    x2: 519,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 569,
    y1: 522.5,
    x2: 622,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 672,
    y1: 522.5,
    x2: 725,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 775,
    y1: 522.5,
    x2: 828,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 878,
    y1: 522.5,
    x2: 931,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 522.5,
    x2: 1034,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 1084,
    y1: 522.5,
    x2: 1137,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1283 136.736C1283 136.736 1299.57 142.206 1307.92 149.173C1315.88 155.812 1324.08 170.228 1324.08 170.228",
    stroke: "white",
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1283 311.492C1283 311.492 1299.57 306.022 1307.92 299.055C1315.88 292.417 1324.08 278 1324.08 278",
    stroke: "white",
    strokeWidth: 5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 1341.5,
    y1: 251,
    x2: 1341.5,
    y2: 198,
    stroke: "white",
    strokeWidth: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.42 336.736C105.42 336.736 88.8521 342.206 80.4993 349.173C72.5403 355.812 64.344 370.228 64.344 370.228",
    stroke: "white",
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.42 513.494C105.42 513.494 88.8521 508.024 80.4993 501.057C72.5403 494.419 64.344 480.002 64.344 480.002",
    stroke: "white",
    strokeWidth: 5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 53,
    y2: -2.5,
    transform: "matrix(0 -1 -1 0 51 451.674)",
    stroke: "white",
    strokeWidth: 5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.5 758C1250.13 758 1269.57 754.547 1287.71 747.838C1305.85 741.129 1322.33 731.295 1336.21 718.899C1350.09 706.502 1361.11 691.785 1368.62 675.588C1376.13 659.391 1380 642.031 1380 624.5C1380 606.969 1376.13 589.609 1368.62 573.412C1361.11 557.215 1350.09 542.498 1336.21 530.101C1322.33 517.705 1305.85 507.871 1287.71 501.162C1269.57 494.453 1250.13 491 1230.5 491L1230.5 557.75C1240.32 557.75 1250.04 559.477 1259.11 562.831C1268.17 566.186 1276.42 571.102 1283.36 577.301C1290.3 583.499 1295.8 590.857 1299.56 598.956C1303.32 607.054 1305.25 615.734 1305.25 624.5C1305.25 633.266 1303.32 641.946 1299.56 650.044C1295.8 658.143 1290.3 665.501 1283.36 671.699C1276.42 677.898 1268.17 682.814 1259.11 686.169C1250.04 689.523 1240.32 691.25 1230.5 691.25V758Z",
    fill: "#222020"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 1187,
    y1: 522.5,
    x2: 1240,
    y2: 522.5,
    stroke: "white",
    strokeWidth: 5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1283 536.736C1283 536.736 1299.57 542.206 1307.92 549.173C1315.88 555.812 1324.08 570.228 1324.08 570.228",
    stroke: "white",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1283 711.492C1283 711.492 1299.57 706.022 1307.92 699.055C1315.88 692.417 1324.08 678 1324.08 678",
    stroke: "white",
    strokeWidth: 5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 1341.5,
    y1: 649,
    x2: 1341.5,
    y2: 596,
    stroke: "white",
    strokeWidth: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1083,
    height: 67,
    transform: "matrix(-1 0 0 1 1234 691)",
    fill: "#222020"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 722.5,
    x2: 303,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 353,
    y1: 722.5,
    x2: 406,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 147,
    y1: 722.5,
    x2: 200,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 466,
    y1: 722.5,
    x2: 519,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 569,
    y1: 722.5,
    x2: 622,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 672,
    y1: 722.5,
    x2: 725,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 775,
    y1: 722.5,
    x2: 828,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 878,
    y1: 722.5,
    x2: 931,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 722.5,
    x2: 1034,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 1084,
    y1: 722.5,
    x2: 1137,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 1187,
    y1: 722.5,
    x2: 1240,
    y2: 722.5,
    stroke: "white",
    strokeWidth: 5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 922.5,
    x2: 303,
    y2: 922.5,
    stroke: "white",
    strokeWidth: 5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 353,
    y1: 922.5,
    x2: 406,
    y2: 922.5,
    stroke: "white",
    strokeWidth: 5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 147,
    y1: 922.5,
    x2: 200,
    y2: 922.5,
    stroke: "white",
    strokeWidth: 5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 466,
    y1: 922.5,
    x2: 519,
    y2: 922.5,
    stroke: "white",
    strokeWidth: 5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 569,
    y1: 922.5,
    x2: 622,
    y2: 922.5,
    stroke: "white",
    strokeWidth: 5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 672,
    y1: 922.5,
    x2: 725,
    y2: 922.5,
    stroke: "white",
    strokeWidth: 5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 775,
    y1: 922.5,
    x2: 828,
    y2: 922.5,
    stroke: "white",
    strokeWidth: 5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 878,
    y1: 922.5,
    x2: 931,
    y2: 922.5,
    stroke: "white",
    strokeWidth: 5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 922.5,
    x2: 1034,
    y2: 922.5,
    stroke: "white",
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.42 736.736C105.42 736.736 88.8521 742.206 80.4993 749.173C72.5403 755.812 64.344 770.228 64.344 770.228",
    stroke: "white",
    strokeWidth: 5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.42 913.494C105.42 913.494 88.8521 908.024 80.4993 901.057C72.5403 894.419 64.344 880.002 64.344 880.002",
    stroke: "white",
    strokeWidth: 5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 53,
    y2: -2.5,
    transform: "matrix(0 -1 -1 0 51 851.674)",
    stroke: "white",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2048_406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 125,
    r: 50,
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M561.168 143V111.55L565.418 115.65H554.668V108H571.068V143H561.168Z",
    fill: "#FF6F00"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2048_406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 126,
    r: 50,
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M986.534 144V137.8L999.634 125.55C1000.57 124.683 1001.25 123.917 1001.68 123.25C1002.15 122.583 1002.45 121.983 1002.58 121.45C1002.75 120.883 1002.83 120.367 1002.83 119.9C1002.83 118.767 1002.45 117.883 1001.68 117.25C1000.95 116.617 999.834 116.3 998.334 116.3C997.068 116.3 995.884 116.583 994.784 117.15C993.684 117.717 992.784 118.567 992.084 119.7L984.734 115.6C986.034 113.4 987.918 111.633 990.384 110.3C992.851 108.967 995.801 108.3 999.234 108.3C1001.93 108.3 1004.3 108.733 1006.33 109.6C1008.37 110.467 1009.95 111.7 1011.08 113.3C1012.25 114.9 1012.83 116.783 1012.83 118.95C1012.83 120.083 1012.68 121.217 1012.38 122.35C1012.08 123.45 1011.5 124.633 1010.63 125.9C1009.8 127.133 1008.55 128.517 1006.88 130.05L996.484 139.65L994.834 136.15H1013.78V144H986.534Z",
    fill: "#FF6F00"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2048_406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 346.5,
    cy: 524.5,
    r: 50.5,
    fill: "white"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M345.77 542.9C343.37 542.9 340.953 542.6 338.52 542C336.087 541.4 333.987 540.55 332.22 539.45L335.77 532C337.203 532.934 338.753 533.65 340.42 534.15C342.12 534.65 343.803 534.9 345.47 534.9C347.137 534.9 348.487 534.584 349.52 533.95C350.553 533.284 351.07 532.367 351.07 531.2C351.07 530.5 350.87 529.884 350.47 529.35C350.07 528.784 349.387 528.367 348.42 528.1C347.453 527.8 346.07 527.65 344.27 527.65H334.77L336.52 507.2H358.82V514.85H340.02L345.07 510.5L343.92 524.3L338.87 519.95H346.62C350.087 519.95 352.87 520.45 354.97 521.45C357.07 522.417 358.603 523.734 359.57 525.4C360.537 527.034 361.02 528.884 361.02 530.95C361.02 533.017 360.47 534.967 359.37 536.8C358.303 538.6 356.653 540.067 354.42 541.2C352.187 542.334 349.303 542.9 345.77 542.9Z",
    fill: "#FF6F00"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2048_406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 564.5,
    cy: 924.5,
    r: 50.5,
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M563.27 906.5C566.57 906.5 569.42 907.15 571.82 908.45C574.253 909.75 576.137 911.684 577.47 914.25C578.837 916.784 579.52 919.95 579.52 923.75C579.52 927.817 578.72 931.284 577.12 934.15C575.553 936.984 573.37 939.15 570.57 940.65C567.803 942.15 564.57 942.9 560.87 942.9C558.937 942.9 557.07 942.667 555.27 942.2C553.47 941.767 551.92 941.15 550.62 940.35L554.22 933.25C555.22 933.95 556.253 934.434 557.32 934.7C558.42 934.934 559.537 935.05 560.67 935.05C563.37 935.05 565.52 934.234 567.12 932.6C568.72 930.967 569.52 928.584 569.52 925.45C569.52 924.884 569.52 924.3 569.52 923.7C569.52 923.067 569.47 922.434 569.37 921.8L571.82 923.85C571.22 925.084 570.437 926.117 569.47 926.95C568.503 927.784 567.37 928.417 566.07 928.85C564.77 929.284 563.287 929.5 561.62 929.5C559.42 929.5 557.403 929.05 555.57 928.15C553.77 927.217 552.32 925.934 551.22 924.3C550.12 922.634 549.57 920.684 549.57 918.45C549.57 916.017 550.187 913.917 551.42 912.15C552.653 910.35 554.303 908.967 556.37 908C558.437 907 560.737 906.5 563.27 906.5ZM563.92 913.55C562.987 913.55 562.17 913.734 561.47 914.1C560.77 914.467 560.203 914.984 559.77 915.65C559.37 916.284 559.17 917.067 559.17 918C559.17 919.334 559.603 920.4 560.47 921.2C561.37 922 562.537 922.4 563.97 922.4C564.937 922.4 565.787 922.217 566.52 921.85C567.253 921.484 567.82 920.967 568.22 920.3C568.62 919.634 568.82 918.85 568.82 917.95C568.82 917.084 568.62 916.334 568.22 915.7C567.82 915.034 567.253 914.517 566.52 914.15C565.787 913.75 564.92 913.55 563.92 913.55Z",
    fill: "#FF6F00"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2048_406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1000.5,
    cy: 524.5,
    r: 50.5,
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.16 542.9C998.898 542.9 996.048 542.25 993.614 540.95C991.214 539.65 989.331 537.717 987.964 535.15C986.631 532.584 985.964 529.417 985.964 525.65C985.964 521.584 986.748 518.134 988.314 515.3C989.914 512.434 992.098 510.25 994.864 508.75C997.664 507.25 1000.9 506.5 1004.56 506.5C1006.53 506.5 1008.41 506.734 1010.21 507.2C1012.05 507.634 1013.6 508.25 1014.86 509.05L1011.26 516.15C1010.26 515.45 1009.21 514.984 1008.11 514.75C1007.05 514.484 1005.95 514.35 1004.81 514.35C1002.11 514.35 999.948 515.167 998.314 516.8C996.714 518.434 995.914 520.817 995.914 523.95C995.914 524.517 995.914 525.117 995.914 525.75C995.948 526.35 996.014 526.967 996.114 527.6L993.614 525.55C994.281 524.317 995.081 523.284 996.014 522.45C996.981 521.617 998.114 520.984 999.414 520.55C1000.75 520.117 1002.23 519.9 1003.86 519.9C1006.06 519.9 1008.06 520.367 1009.86 521.3C1011.7 522.2 1013.16 523.484 1014.26 525.15C1015.36 526.784 1015.91 528.717 1015.91 530.95C1015.91 533.384 1015.3 535.5 1014.06 537.3C1012.83 539.067 1011.18 540.45 1009.11 541.45C1007.05 542.417 1004.73 542.9 1002.16 542.9ZM1001.56 535.85C1002.5 535.85 1003.31 535.667 1004.01 535.3C1004.75 534.934 1005.31 534.417 1005.71 533.75C1006.11 533.084 1006.31 532.3 1006.31 531.4C1006.31 530.067 1005.86 529 1004.96 528.2C1004.1 527.4 1002.95 527 1001.51 527C1000.55 527 999.698 527.184 998.964 527.55C998.264 527.917 997.698 528.434 997.264 529.1C996.864 529.767 996.664 530.55 996.664 531.45C996.664 532.317 996.864 533.084 997.264 533.75C997.664 534.384 998.231 534.9 998.964 535.3C999.698 535.667 1000.56 535.85 1001.56 535.85Z",
    fill: "#FF6F00"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2048_406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 325,
    r: 50,
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M329.845 336.3V329.85L345.545 308H355.795L340.545 329.85L335.845 328.45H363.195V336.3H329.845ZM348.345 343V336.3L348.645 328.45V322.5H357.995V343H348.345Z",
    fill: "#FF6F00"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_2048_406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 782,
    cy: 325,
    r: 50,
    fill: "white"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M780.837 343.7C778.403 343.7 775.97 343.4 773.537 342.8C771.137 342.2 769.037 341.35 767.237 340.25L770.837 332.8C772.237 333.733 773.787 334.45 775.487 334.95C777.22 335.45 778.903 335.7 780.537 335.7C782.237 335.7 783.587 335.383 784.587 334.75C785.587 334.117 786.087 333.217 786.087 332.05C786.087 331.017 785.67 330.2 784.837 329.6C784.003 328.967 782.637 328.65 780.737 328.65H776.587V322.4L785.987 312.25L786.937 315.65H769.037V308H794.337V314.2L784.937 324.35L780.087 321.6H782.787C787.153 321.6 790.453 322.583 792.687 324.55C794.953 326.483 796.087 328.983 796.087 332.05C796.087 334.05 795.537 335.933 794.437 337.7C793.37 339.467 791.72 340.917 789.487 342.05C787.253 343.15 784.37 343.7 780.837 343.7Z",
    fill: "#FF6F00"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_2048_406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 724,
    r: 50,
    fill: "white"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M345.976 742.7C342.943 742.7 340.293 742.25 338.026 741.35C335.76 740.45 333.976 739.183 332.676 737.55C331.41 735.883 330.776 733.933 330.776 731.7C330.776 729.5 331.41 727.633 332.676 726.1C333.976 724.533 335.76 723.35 338.026 722.55C340.326 721.717 342.976 721.3 345.976 721.3C348.976 721.3 351.61 721.717 353.876 722.55C356.176 723.35 357.96 724.533 359.226 726.1C360.526 727.633 361.176 729.5 361.176 731.7C361.176 733.933 360.543 735.883 359.276 737.55C358.01 739.183 356.226 740.45 353.926 741.35C351.66 742.25 349.01 742.7 345.976 742.7ZM345.976 735.75C347.576 735.75 348.843 735.367 349.776 734.6C350.743 733.833 351.226 732.767 351.226 731.4C351.226 730.067 350.743 729.017 349.776 728.25C348.843 727.45 347.576 727.05 345.976 727.05C344.376 727.05 343.093 727.45 342.126 728.25C341.193 729.017 340.726 730.067 340.726 731.4C340.726 732.767 341.193 733.833 342.126 734.6C343.093 735.367 344.376 735.75 345.976 735.75ZM345.976 726.2C343.243 726.2 340.826 725.817 338.726 725.05C336.66 724.283 335.026 723.183 333.826 721.75C332.626 720.283 332.026 718.533 332.026 716.5C332.026 714.4 332.61 712.6 333.776 711.1C334.976 709.6 336.626 708.433 338.726 707.6C340.826 706.733 343.243 706.3 345.976 706.3C348.743 706.3 351.16 706.733 353.226 707.6C355.326 708.433 356.96 709.6 358.126 711.1C359.326 712.6 359.926 714.4 359.926 716.5C359.926 718.533 359.326 720.283 358.126 721.75C356.96 723.183 355.326 724.283 353.226 725.05C351.126 725.817 348.71 726.2 345.976 726.2ZM345.976 720.6C347.243 720.6 348.26 720.283 349.026 719.65C349.793 718.983 350.176 718.083 350.176 716.95C350.176 715.75 349.776 714.833 348.976 714.2C348.21 713.567 347.21 713.25 345.976 713.25C344.743 713.25 343.743 713.567 342.976 714.2C342.21 714.833 341.826 715.75 341.826 716.95C341.826 718.083 342.21 718.983 342.976 719.65C343.743 720.283 344.743 720.6 345.976 720.6Z",
    fill: "#FF6F00"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_2048_406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 782,
    cy: 724,
    r: 50,
    fill: "white"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M773.204 742L786.854 710.65L789.504 714.85H771.754L775.804 710.3V720.25H767.354V707H796.354V713.2L784.004 742H773.204Z",
    fill: "#FF6F00"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_2048_406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 925,
    r: 50,
    fill: "white"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M978.804 943V911.55L983.054 915.65H972.304V908H988.704V943H978.804ZM1011.92 943.7C1008.92 943.7 1006.25 942.983 1003.92 941.55C1001.62 940.117 999.801 938.05 998.468 935.35C997.134 932.65 996.468 929.367 996.468 925.5C996.468 921.633 997.134 918.35 998.468 915.65C999.801 912.95 1001.62 910.883 1003.92 909.45C1006.25 908.017 1008.92 907.3 1011.92 907.3C1014.88 907.3 1017.52 908.017 1019.82 909.45C1022.15 910.883 1023.98 912.95 1025.32 915.65C1026.65 918.35 1027.32 921.633 1027.32 925.5C1027.32 929.367 1026.65 932.65 1025.32 935.35C1023.98 938.05 1022.15 940.117 1019.82 941.55C1017.52 942.983 1014.88 943.7 1011.92 943.7ZM1011.92 935.6C1012.98 935.6 1013.92 935.267 1014.72 934.6C1015.55 933.933 1016.2 932.867 1016.67 931.4C1017.13 929.9 1017.37 927.933 1017.37 925.5C1017.37 923.033 1017.13 921.067 1016.67 919.6C1016.2 918.133 1015.55 917.067 1014.72 916.4C1013.92 915.733 1012.98 915.4 1011.92 915.4C1010.85 915.4 1009.9 915.733 1009.07 916.4C1008.27 917.067 1007.62 918.133 1007.12 919.6C1006.65 921.067 1006.42 923.033 1006.42 925.5C1006.42 927.933 1006.65 929.9 1007.12 931.4C1007.62 932.867 1008.27 933.933 1009.07 934.6C1009.9 935.267 1010.85 935.6 1011.92 935.6Z",
    fill: "#FF6F00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2048_406",
    x: 494.833,
    y: 55.8333,
    width: 138.333,
    height: 138.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2048_406",
    x: 930.833,
    y: 56.8333,
    width: 138.333,
    height: 138.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2048_406",
    x: 276.833,
    y: 454.833,
    width: 139.333,
    height: 139.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2048_406",
    x: 494.833,
    y: 854.833,
    width: 139.333,
    height: 139.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2048_406",
    x: 930.833,
    y: 454.833,
    width: 139.333,
    height: 139.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2048_406",
    x: 276.833,
    y: 255.833,
    width: 138.333,
    height: 138.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_2048_406",
    x: 712.833,
    y: 255.833,
    width: 138.333,
    height: 138.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_2048_406",
    x: 276.833,
    y: 654.833,
    width: 138.333,
    height: 138.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_2048_406",
    x: 712.833,
    y: 654.833,
    width: 138.333,
    height: 138.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_2048_406",
    x: 930.833,
    y: 855.833,
    width: 138.333,
    height: 138.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.58333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.517647 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2048_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2048_406",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.5396fe347001d2b22e5d4cbe10dc2286.svg";
export { ForwardRef as ReactComponent };